/**
 * @generated SignedSource<<1b364daf298a12f467e2d47cd87b1aff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
export type IssueFieldSingleSelectOptionColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type IssueMultiSelectFieldPickerOption$data = {
  readonly color: IssueFieldSingleSelectOptionColor;
  readonly description: string | null | undefined;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "IssueMultiSelectFieldPickerOption";
};
export type IssueMultiSelectFieldPickerOption$key = {
  readonly " $data"?: IssueMultiSelectFieldPickerOption$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueMultiSelectFieldPickerOption">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "IssueMultiSelectFieldPickerOption"
};

(node as any).hash = "6c35a317c9bf7c864b0b6cccdbfeee1d";

export default node;
